import type {StateProvider, Transition} from '@uirouter/angularjs';
import LoansController from './loans.controller';
import template from './loans.tpl.ftl';
import {includesAllFrom} from 'shared/utils/array-utils';

/*@ngInject*/
export default function loansRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state('loans', {
            url: '/loans?loanState',
            templateUrl: template,
            controller: LoansController,
            controllerAs: '$ctrl',
            resolve: {
                toProcess: ($transition$: Transition) => {
                    const loanState = $transition$.params()?.loanState;

                    return Array.isArray(loanState) && loanState.length === 2 && includesAllFrom(loanState, ['UNSENT_RESERVATION', 'UNPROCESSED_ORDER']);
                }
            }
        });
}